/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/*
 * This is really a duplication of the normalizing that jQuery does.
 * However, for this chaining strategy to work, we need this to happen
 * before our other classes in the chain get called. Otherwise we need
 * to duplicate this logic for each class.
 *
 * @namespace Ajax
 */
class Normalize {
  constructor (cache, nextAjax) {
    this.ajax = this.ajax.bind(this)
    this.nextAjax = nextAjax
  }

  ajax (url, options) {
    /*
     * Normalizing the arguments
     * https://github.com/jquery/jquery/blob/693f1b537b0a19cda8b7e8f5379bffa5351b8a6e/src/ajax.js#L383-L392
     */
    if (typeof url === 'object') {
      options = url;
      ({ url } = options)
    }
    if (!options) { options = {} }
    options.url = url
    /*
     * Setting method to GET as the default method unless specified in options.type
     * https://github.com/jquery/jquery/blob/91850ecbbe04ad8f5d89dc050aa1d9002047c435/src/ajax.js#L299
     * https://github.com/jquery/jquery/blob/91850ecbbe04ad8f5d89dc050aa1d9002047c435/src/ajax.js#L529
     */
    options.type = options.method || options.type || 'GET'
    return this.nextAjax(options)
  }
}

export default Normalize
